import { Row as RowAntd, Typography } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  .hidden {
    display: none;
  }
`;

export const CardSelectedCliente = styled.div`
  border-radius: 2px;
  border: 1px solid #d9d9d9;
  height: 132px;
  overflow: auto;
  margin-bottom: 16px;

  p {
    margin-bottom: 1px;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    color: rgba(0, 0, 0, 0.85);
  }
`;

export const CardLine = styled(RowAntd)`
  padding: 11px 36px 6px 24px;

  &:hover {
    background: #f5f5f5;
  }
`;

const { Text } = Typography;

export const SwitchLabel = styled(Text)`
  margin-right: 8px;
`;

export const FormLabel = styled(Text)`
  margin-right: 8px;
`;
